import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { useParams } from "react-router";
import { useQuery } from "@apollo/react-hooks";
import { PAGE_FOR_STATIC_PAGE } from "@components/pages/StaticPage/queries";
import { pageForStaticPage } from "@components/pages/StaticPage/__generated__/pageForStaticPage";
import { Loading } from "@atoms";
import { Container } from "react-bootstrap";
import { useAlert } from "react-alert";
import SEO from "react-seo-component";

const StaticPage: React.FC<IProps> = (
  { }: IProps) => {
  //@ts-ignore
  const { slug } = useParams();
  const alert = useAlert();
  const { data, error, loading } = useQuery<pageForStaticPage>(PAGE_FOR_STATIC_PAGE, {
    variables: { slug },
  });

  return data && (
    <Container>
      <SEO
        title={data.page?.seoTitle || ""}
        titleTemplate={data.page?.seoTitle || ""}
        description={data.page?.seoDescription || ""}
        pathname=""
        siteLanguage="en"
        siteLocale="en_GB"
        twitterUsername=""
      />
      <S.Wrapper dangerouslySetInnerHTML={{ __html: data?.page?.content }} />
    </Container>
  ) || <Loading />;
};

export { StaticPage }
